module.exports = __webpack_public_path__ + "static/media/Marjan.d1a1e976.jpg";